import { Box, Card, Divider, IconButton, Menu, styled } from '@mui/material';
import { themeColors } from 'src/theme';

export const StyledContractorCard = styled(Card)(({ theme }) => ({
  alignItems: 'center',
  textAlign: 'center',
  position: 'relative',
  boxShadow: 'none',
  border: `1px solid ${themeColors.grayMedium}`,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const ContractorInfoContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  alignSelf: 'stretch',
  flex: 1,
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  width: '100%',
  borderBottom: `1px solid ${themeColors.grayMedium}`,
}));

export const CardContent = styled(Box)(({ theme }) => ({
  textAlign: 'center',
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '6px',
    backgroundColor: '#fff',
    boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.06)',
    width: '220px',
  },
  '& .MuiList-root': {
    padding: 0,
  },
}));

export const LabelContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: 16,
  top: 16,
  borderRadius: '4px',
  whiteSpace: 'nowrap',
  backgroundColor: themeColors.lightYellow,
  width: '70px',
  height: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
